import React from 'react';
import { AppBar } from '@mui/material';
import { Toolbar, IconButton } from '@mui/material';
import logoAlacuenta from '../../img/Alacuenta-logo.png';
import Typography from '@mui/material/Typography';
import { SERVICE_PREFIX } from '../../config-front';
import { Link } from 'react-router-dom';
import AppMenu from './AppMenu';

class AppToolBar extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      menuEl: null
    };
  }
  handleClose = () => {
    this.setState({
      menuEl: null
    });
  }
  goToContactPage = () => {
    this.handleClose();
    window.location.hash = 'contactanos';
  }
  render = () => {
    return (
      <AppBar position="sticky" className="app-bar" style={SERVICE_PREFIX.includes("http://localhost") ? { backgroundColor:"#0f0"} : {}}>
        {this.props.isMobileVersion &&
          <Toolbar>
            <IconButton edge="start" className="menuButton" color="inherit" aria-label="menu">
              {/*<MenuIcon />*/}
            </IconButton>

            <Typography className="title">
              <Link to="/">
                <span className="logo-alacuenta">
                  <img src={logoAlacuenta} alt="logo-alacuenta"/>
                </span>
                <div className="title-container">
                  <h1 className="title-app"> wezpi </h1>
                </div>
              </Link>
            </Typography>

            <AppMenu />

          </Toolbar>
        }

{!this.props.isMobileVersion &&
          <Toolbar>
            <div className="title">
              <Link to="/">
                <span className="logo-alacuenta">
                  <img src={logoAlacuenta} alt="logo-alacuenta"/>
                </span>
                <div className="title-container">
                  <h1 className="title-app"> wezpi </h1>
                </div>
              </Link>
            </div>

            <AppMenu />

          </Toolbar>
        }
      </AppBar>
    );
  }
}

// export default withRouter(AppToolBar);
export default (AppToolBar);